import { Action } from '@ngrx/store'

export const INIT_DIRECT_UPLOAD = '[Direct Upload] Init'
export const START_DIRECT_UPLOAD = '[Direct Upload] Start Direct Upload'
export const ERROR_DIRECT_UPLOAD = '[Direct Upload] Error'
export const PROGRESS_DIRECT_UPLOAD = '[Direct Upload] Progress Direct Upload'
export const COMPLETE_DIRECT_UPLOAD = '[Direct Upload] Complete Direct Upload'

export class InitDirectUpload implements Action {
  readonly type = INIT_DIRECT_UPLOAD
  constructor() {}
}

export class StartDirectUpload implements Action {
  readonly type = START_DIRECT_UPLOAD
  constructor() {}
}

export class ProgressDirectUpload implements Action {
  readonly type = PROGRESS_DIRECT_UPLOAD
  constructor(public progress: number) {}
}

export class CompleteDirectUpload implements Action {
  readonly type = COMPLETE_DIRECT_UPLOAD

  constructor(public blob: ActiveStorage.Blob) {}
}

export class ErrorDirectUpload implements Action {
  readonly type = ERROR_DIRECT_UPLOAD

  constructor(public msg: string) {}
}


export type All = InitDirectUpload | StartDirectUpload | ProgressDirectUpload | CompleteDirectUpload | ErrorDirectUpload



// WEBPACK FOOTER //
// ./src/actions/direct-upload.ts